import React from 'react';

import Header from './header';
import Banner from './banner';
import Dale from './dale';


import { UserProvider, useUser } from '../../context/UserContext'

export default function Home() {
  return (
    <>
      <Header />
      <Banner />
      <Dale />
    </>
  )
}